import React, { useMemo, useState, useEffect } from "react";
import axios from "axios";
import Select from "react-select";

export default function BranchSelector({ value, onChange, onSelect }) {
    const [branches, setBranches] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        async function fetchBranches() {
            setLoading(true);
            try {
                // Use correct endpoint and attach JWT token
                const token = localStorage.getItem("token") || sessionStorage.getItem("token");
                const backendUrl = process.env.REACT_APP_API_URL;
                const res = await axios.get(`${backendUrl}/api/admin/branches`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                setBranches(res.data.data || res.data || []);
                setError(null);
            } catch (err) {
                setError("Failed to load branches");
                setBranches([]);
            }
            setLoading(false);
        }
        fetchBranches();
    }, []);

    const options = useMemo(() => {
        const base = [{ value: "", label: "All Branches" }];
        const items = branches.map(branch => ({
            value: String(branch.id),
            label: branch.name,
        }));
        return [...base, ...items];
    }, [branches]);

    const selectedOption = useMemo(() => {
        return options.find(opt => String(opt.value) === String(value || "")) || options[0];
    }, [options, value]);

    const reactSelectStyles = useMemo(() => ({
        control: (base) => ({
            ...base,
            minHeight: 36,
            borderRadius: 8,
            borderColor: "#d1d5db",
            boxShadow: "none",
            fontSize: 14,
        }),
        menu: (base) => ({ ...base, borderRadius: 10, zIndex: 9999 }),
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        option: (base, state) => ({
            ...base,
            background: state.isSelected ? "#e5e7eb" : state.isFocused ? "#f3f4f6" : "#fff",
            color: "#111827",
        }),
    }), []);

    return (
        <div className="flex items-center gap-2">
            <label className="text-sm font-medium text-gray-700">Branch:</label>
            <div className="min-w-[200px]">
                <Select
                    classNamePrefix="react-select"
                    styles={reactSelectStyles}
                    options={options}
                    value={selectedOption}
                    onChange={(opt) => {
                        const nextValue = opt?.value || "";
                        onChange(nextValue);
                        if (onSelect) {
                            onSelect(opt || { value: "", label: "All Branches" });
                        }
                    }}
                    isSearchable={false}
                    placeholder="All Branches"
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    isDisabled={loading}
                />
            </div>
            {loading && <span className="text-xs text-gray-400">Loading...</span>}
            {error && <span className="text-xs text-red-500">{error}</span>}
        </div>
    );
}
